import React from 'react';
import Chip from '@mui/material/Chip';

const CustomChip = (props) => {

    const stl = estatus => {
        switch (estatus) {
            // estatus de reportes
            case 'PENDIENTE': return { backgroundColor: '#ffee58', color: '#000' };
            case 'DIAGNOSTICADO': return { backgroundColor: '#42a5f5', color: '#000' };
            case 'EN ESPERA DE AUTORIZACION': return { backgroundColor: '#ffa726', color: '#000' };
            case 'AUTORIZADO': return { backgroundColor: '#ec407a', color: '#FFF' };
            case 'EN REPARACIÓN': return { backgroundColor: '#ab47bc', color: '#FFF' };
            case 'ATENDIDO': return { backgroundColor: '#26a69a', color: '#FFF' };
            case 'FACTURADO': return { backgroundColor: '#66bb6a', color: '#FFF' };
            case 'CANCELADO': return { backgroundColor: '#ef5350', color: '#FFF' };
            case 'EN GARANTÍA': return { backgroundColor: '#757575', color: '#FFF' };
            case 'BAJA DE EQUIPO': return { backgroundColor: '#8d6e63', color: '#FFF' };
            // estatud de facturas
            case 'PENDIENTE DE FIRMAS': return { backgroundColor: '#ffee58', color: '#000' };
            case 'RECIBIDA POR EL HOSPITAL': return { backgroundColor: '#42a5f5', color: '#000' };
            case 'FIRMADA': return { backgroundColor: '#ffa726', color: '#000' };
            case 'EN REVISIÓN PARA PAGO': return { backgroundColor: '#ec407a', color: '#FFF' };
            case 'EN ESPERA DE PAGO': return { backgroundColor: '#ab47bc', color: '#FFF' };
            case 'PAGADA': return { backgroundColor: '#66bb6a', color: '#FFF' };
            case 'CANCELADA': return { backgroundColor: '#ef5350', color: '#FFF' };
            case 'EN REVISION POR ERRORES': return { backgroundColor: '#757575', color: '#FFF' };
            // estatus de contratos
            case 'EN CURSO': return { backgroundColor: '#42a5f5', color: '#000' };
            case 'TERMINADO': return { backgroundColor: '#66bb6a', color: '#FFF' };
            default: return {}
        }
    }

    const stl2 = estatus => {
        switch (estatus) {
            // estatus de reportes
            case 'PENDIENTE': return { borderColor: '#ffee58', color: 'palette.text' };
            case 'DIAGNOSTICADO': return { borderColor: '#42a5f5', color: 'palette.text' };
            case 'EN ESPERA DE AUTORIZACION': return { borderColor: '#ffa726', color: 'palette.text' };
            case 'AUTORIZADO': return { borderColor: '#ec407a', color: 'palette.text' };
            case 'EN REPARACIÓN': return { borderColor: '#ab47bc', color: 'palette.text' };
            case 'ATENDIDO': return { borderColor: '#26a69a', color: 'palette.text' };
            case 'FACTURADO': return { borderColor: '#66bb6a', color: 'palette.text' };
            case 'CANCELADO': return { borderColor: '#ef5350', color: 'palette.text' };
            case 'EN GARANTÍA': return { borderColor: '#757575', color: 'palette.text' };
            case 'BAJA DE EQUIPO': return { borderColor: '#8d6e63', color: 'palette.text' };
            // estatus de facturas
            case 'PENDIENTE DE FIRMAS': return { borderColor: '#ffee58', color: 'palette.text' };
            case 'RECIBIDA POR EL HOSPITAL': return { borderColor: '#42a5f5', color: 'palette.text' };
            case 'FIRMADA': return { borderColor: '#ffa726', color: 'palette.text' };
            case 'EN REVISIÓN PARA PAGO': return { borderColor: '#ec407a', color: 'palette.text' };
            case 'EN ESPERA DE PAGO': return { borderColor: '#ab47bc', color: 'palette.text' };
            case 'PAGADA': return { borderColor: '#66bb6a', color: 'palette.text' };
            case 'CANCELADA': return { borderColor: '#ef5350', color: 'palette.text' };
            case 'EN REVISION POR ERRORES': return { borderColor: '#757575', color: 'palette.text' };
            // estatus de contratos
            case 'EN CURSO': return { borderColor: '#42a5f5', color: 'palette.text' };
            case 'TERMINADO': return { borderColor: '#66bb6a', color: 'palette.text' };
            default: return {}
        }
    }

    return (
        <>
            {props.variant === 'outlined' ?
                <Chip
                    size={props.size}
                    label={props.label}
                    className={props.className}
                    style={props.estatus ? stl2(props.estatus) : { borderColor: props.borderColor, color: props.color }}
                    variant={props.variant}
                />
                : <Chip
                    size={props.size}
                    label={props.label}
                    className={props.className}
                    style={props.estatus ? stl(props.estatus) : { backgroundColor: props.backgroundColor, color: props.color }}
                    variant={props.variant}
                />
            }
        </>
    );
}

export default CustomChip;